import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modelItem", "providerFilter", "useCaseFilter", "resultCount", "clearButton", "emptyState"]

  connect() {
    // Initialize with all providers selected
    this.activeProviders = new Set()
    this.providerFilterTargets.forEach(filter => {
      const provider = filter.dataset.provider
      this.activeProviders.add(provider)
    })
    this.activeUseCase = null
    this.updateClearButtonVisibility()
  }

  toggleProvider(event) {
    const provider = event.currentTarget.dataset.provider
    const checkbox = event.currentTarget.querySelector('input[type="checkbox"]')

    if (checkbox) {
      // Checkbox was clicked directly
      if (checkbox.checked) {
        this.activeProviders.add(provider)
      } else {
        this.activeProviders.delete(provider)
      }
    } else {
      // Label/container was clicked
      if (this.activeProviders.has(provider)) {
        this.activeProviders.delete(provider)
      } else {
        this.activeProviders.add(provider)
      }
    }

    this.applyFilters()
  }

  selectUseCase(event) {
    event.preventDefault()
    const useCase = event.currentTarget.dataset.useCase

    // Toggle use case - if already selected, deselect it
    if (this.activeUseCase === useCase) {
      this.activeUseCase = null
      event.currentTarget.classList.remove('active')
    } else {
      // Deselect previous
      this.useCaseFilterTargets.forEach(btn => btn.classList.remove('active'))
      // Select new
      this.activeUseCase = useCase
      event.currentTarget.classList.add('active')
    }

    this.applyFilters()
  }

  clearFilters(event) {
    event.preventDefault()

    // Reset providers to all selected
    this.activeProviders.clear()
    this.providerFilterTargets.forEach(filter => {
      const provider = filter.dataset.provider
      this.activeProviders.add(provider)
      const checkbox = filter.querySelector('input[type="checkbox"]')
      if (checkbox) checkbox.checked = true
      filter.classList.remove('active')
    })

    // Clear use case
    this.activeUseCase = null
    this.useCaseFilterTargets.forEach(btn => btn.classList.remove('active'))

    this.applyFilters()
  }

  applyFilters() {
    let visibleCount = 0

    this.modelItemTargets.forEach(item => {
      const itemProvider = item.dataset.provider
      const itemUseCases = (item.dataset.useCases || '').split(',').filter(uc => uc)

      let showByUseCase = true

      // Provider filter (show only if item's provider is in selected set)
      let showByProvider = this.activeProviders.has(itemProvider)

      // Use case filter (show if no use case selected OR item has the selected use case)
      if (this.activeUseCase) {
        showByUseCase = itemUseCases.includes(this.activeUseCase)
      }

      // Show item only if it passes both filters
      if (showByProvider && showByUseCase) {
        item.classList.remove('model-item-hidden')
        visibleCount++
      } else {
        item.classList.add('model-item-hidden')
      }
    })

    // Update count
    if (this.hasResultCountTarget) {
      const total = this.modelItemTargets.length
      const totalProviders = this.providerFilterTargets.length
      const hasFilteredProviders = this.activeProviders.size < totalProviders
      if (hasFilteredProviders || this.activeUseCase) {
        this.resultCountTarget.textContent = `${visibleCount} of ${total} models`
      } else {
        this.resultCountTarget.textContent = `${total} models`
      }
    }

    // Show/hide empty state
    if (this.hasEmptyStateTarget) {
      if (visibleCount === 0) {
        this.emptyStateTarget.classList.remove('d-none')
      } else {
        this.emptyStateTarget.classList.add('d-none')
      }
    }

    this.updateClearButtonVisibility()
  }

  updateClearButtonVisibility() {
    if (this.hasClearButtonTarget) {
      const totalProviders = this.providerFilterTargets.length
      const hasFilteredProviders = this.activeProviders.size < totalProviders
      const hasActiveFilters = hasFilteredProviders || this.activeUseCase
      if (hasActiveFilters) {
        this.clearButtonTarget.classList.remove('d-none')
      } else {
        this.clearButtonTarget.classList.add('d-none')
      }
    }
  }
}
